import Menu from "../modules/Menu";
import Swiper from "swiper/bundle";
import searchBox from "../modules/serach";
//import "bootstrap/js/src/dropdown";
import Dropdown from "bootstrap/js/src/dropdown";
import "bootstrap/js/src/collapse";
import intlTelInput from 'intl-tel-input';
import CollapseFooterMenus from '../modules/CollapseFooterMenus';
import MobileSlider from "../modules/MobileSlider";
import wishlist from "../modules/WishList";
import FloatingLabels from "../modules/FloatingLabels";
import '../modules/tips';
import '../modules/copy';
import qty from '../modules/qty';
import updateCart from "../util/updateCart";
import DistributorList from "../modules/DistributorList";
import CartWidget from "../modules/CartWidget";
import alert from '../modules/Popup';
import JSShare from "js-share";
import CountrySwitcher from "../modules/CountrySwitcher";
import Cart from "../modules/Cart";

const {__} = wp.i18n;

export default {
  init() {

    let canopia = window.canopia || {};



    //Init the mobile menu

    new Menu();

    //Search

    searchBox();

    //Dropdowns

    const dropDownInit = () => {
      const dropdownElementList = document.querySelectorAll('.dropdown-toggle');

      if (dropdownElementList && dropdownElementList.length > 0) {
        const afterFlip = {
          name: 'afterFlip',
          requires: ['flip'],
          enabled: true,
          phase: 'main',
          fn({ state }) {
            if(state.elements.reference.dataset.placement !== state.placement) {
              state.elements.reference.dataset.placement = state.placement;
            }
          },
        };

        [...dropdownElementList].map(dropdownToggleEl => {
          if(dropdownToggleEl.classList.contains('btn-distributors-dropdown')) {
            return new Dropdown(dropdownToggleEl, {
              popperConfig: {
                modifiers: [afterFlip],
              }
            })
          }
          return new Dropdown(dropdownToggleEl)
        })
      }
    }

    document.body.addEventListener('wishlist_products_loaded', dropDownInit);
    document.body.addEventListener('compare_products_loaded', dropDownInit);

    dropDownInit();



    //Init all sliders

    try {
      if (canopia.sliders && Array.isArray(canopia.sliders)) {
        canopia.sliders.forEach(slider => {
          if (slider.options.breakpointOnly !== undefined) {
            new MobileSlider(slider.options.breakpointOnly, slider.selector, slider.options);
          } else {
            new Swiper(slider.selector, slider.options);
          }
        });

        //Add hero slider images
        document.getElementById("main").addEventListener("pointerdown", () => {
          if (typeof window.heroLoded === 'undefined') {
            window.heroLoded = true;

            const heroSlides = document.querySelectorAll('.hero-slide');

            if(heroSlides) {
              heroSlides.forEach(item => {
                if (!item.style.backgroundImage && item.dataset.bg && item.dataset.bg !== 'false') {
                  item.style.backgroundImage = `url('${item.dataset.bg}')`;
                }
              })
            }
          }
        });

      }
    } catch (e) {
      //
    }

    //Wishlist
    wishlist.init();

    //FloatingLabels
    FloatingLabels();

    //Add to cart dropdown

    let shopDropdowns = document.querySelectorAll('.btn-distributors-dropdown');

    if (shopDropdowns && shopDropdowns.length > 0) {
      shopDropdowns.forEach(btn => new DistributorList(btn));
    }

    if ( typeof palram.checkout_params !== 'undefined' || typeof palram.cart_params !== 'undefined' ) {
      // Cart and Cart Update

      document.body.addEventListener('qty_updated', (event) => {
        if (!event.detail.location) {
          return;
        }
        updateCart(event.detail)
      });

      new Cart();

      // Cart widget Dropdown;
      new CartWidget('max-width: 767px');
    }


    document.body.addEventListener('click', event => {
      if (event.target.classList.contains('btn-distributors-dropdown') && 'true' !== event.target.dataset.distributorsList) {
        new DistributorList(event.target);
      }
    });


    //Show more buttons

    const showMoreButtons = document.querySelectorAll('.media-hidden-expand-btn');
    if (showMoreButtons && showMoreButtons.length > 0) {
      showMoreButtons.forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        const target = button.parentElement.querySelector('.media-hidden-text');
        if (!target) {
          return;
        }
        const currentText = button.textContent;
        const nextText = button.dataset.text;
        if ('false' === button.dataset.expanded) {
          if (!target.classList.contains('expanded')) {
            target.classList.add('expanded');
          }
          button.classList.remove('btn-yellow-green');
          if (!button.classList.contains('btn-transparent')) {
            button.classList.add('btn-transparent');
          }
          button.dataset.expanded = 'true';
        } else {
          target.classList.remove('expanded');
          button.classList.remove('btn-transparent');
          if (!button.classList.contains('btn-yellow-green')) {
            button.classList.add('btn-yellow-green');
          }
          button.dataset.expanded = 'false';
        }

        button.textContent = nextText;
        button.dataset.text = currentText;

      }))
    }

    //CF-7
    const cfs7forms = document.querySelectorAll('.wpcf7');
    const cfs7Terms = document.getElementById('wpcf7-terms');

    if (cfs7Terms) {
      const cfs7TermlLabel = cfs7Terms.querySelector('.wpcf7-list-item-label');
      if (cfs7TermlLabel) {
        cfs7TermlLabel.innerHTML = __('I agree to Canopia website <a href="%link%">privacy policy</a>', 'canopia').replace('%link%', palram.privacy_url);
      }
    }

    if (cfs7forms && cfs7forms.length > 0) {
      cfs7forms.forEach(form => {
        form.addEventListener('wpcf7invalid', event => {
          try {
            alert.open({
              title: __('Oh no...', 'canopia'),
              type: 'warning',
              message: `<p>${event.detail.apiResponse.message}</p>`,
              close: {
                text: __('Try again', 'canopia'),
              },
            })
          } catch (e) {
          }
        });

        form.addEventListener('wpcf7mailsent', event => {
          alert.open({
            title: __('Success', 'canopia'),
            type: 'success',
            message: `<p>${__('Your message has been sent')}</p>`,
            close: {
              text: __('Ok', 'canopia'),
            },
          });
        });
        form.addEventListener('submit', () => {
          const button = form.querySelector('[type="submit"]');
          if (!button) {
            return;
          }
          button.classList.add('loading');
          button.setAttribute('disabled', 'disabled');
        });
        form.addEventListener('wpcf7submit', event => {
          const button = form.querySelector('[type="submit"]');
          if (button) {
            button.classList.remove('loading');
            button.removeAttribute('disabled');
          }
          try {
            if ('acceptance_missing' === event.detail.status) {
              alert.open({
                title: __('Oh no...', 'canopia'),
                type: 'warning',
                message: `<p>${event.detail.apiResponse.message}</p>`,
                close: {
                  text: __('Try again', 'canopia'),
                },
              })
            }
          } catch (e) {

          }
        });
      });
    }

    //Share

    document.body.addEventListener('click', event => {
      const {target} = event;
      if (!target.classList.contains('social_share')) {
        return;
      }
      return JSShare.go(target);
    });

    //CountrySwitcher

    if ('yes' === palram.country_switcher_enabled) {
      new CountrySwitcher();
    }

    //Intl tel input

    const phoneInputs = document.querySelectorAll('input[name="your-phone"]');
    const adjustFloatingLabelForIntlTelInput = (input, label, force = false) => {
      if (force || '' !== input.value) {
        label.removeAttribute('style');
      } else {
        label.style.left = window.getComputedStyle(input).getPropertyValue('padding-left')
      }
    }

    if (phoneInputs && phoneInputs.length > 0) {
      let countryData = window.intlTelInputGlobals.getCountryData();
      for (let i = 0; i < countryData.length; i++) {
        let country = countryData[i];
        country.name = country.name.replace(/ *\([^)]*\) */g, "");
      }

      phoneInputs.forEach(phoneInput => {
        const inputName = phoneInput.name;

        let iti = intlTelInput(phoneInput, {
          separateDialCode: true,
          nationalMode: false,
          initialCountry: palram.default_country_code.toLowerCase(),
          hiddenInput: inputName,
          utilsScript: `${palram.theme_uri}/public/scripts/intl-tel-input/utils.js`,
        });
        phoneInput.name = `${inputName}-full`;

        iti.promise.then(() => {
          const floatingWrapper = phoneInput.closest('.form-floating');
          if (!floatingWrapper) {
            return;
          }
          const parent = phoneInput.parentElement;
          const label = floatingWrapper.querySelector('.form-label');

          if (!label) {
            return;
          }

          floatingWrapper.classList.remove('form-floating');
          parent.classList.add('form-floating');
          parent.classList.add('d-block');
          parent.appendChild(label);

          adjustFloatingLabelForIntlTelInput(phoneInput, label);

          phoneInput.addEventListener('blur', () => {
            adjustFloatingLabelForIntlTelInput(phoneInput, label)
          });

          phoneInput.addEventListener('focus', () => {
            adjustFloatingLabelForIntlTelInput(phoneInput, label, true)
          });

          const updateHiddenInput = (event) => {
            const hidden = event.target.parentElement.querySelector(`input[name="${inputName}"]`);
            if (hidden) {
              hidden.value = iti.getNumber();
            }
          }

          phoneInput.addEventListener('change', updateHiddenInput);
          phoneInput.addEventListener('keyup', updateHiddenInput);
          phoneInput.addEventListener('countrychange', updateHiddenInput);
        });
      });
    }

    // Order receipt print button
    const $printLink = $('.btn-print');
    if ($printLink) {
      $printLink.on('click', (event) => {
        event.preventDefault();
        let el = $(this);

        el.trigger('printLinkInit');

        let uri = new URL(palram.ajax_url);
        uri.searchParams.set('order_id', $printLink.data('order'));
        uri.searchParams.set('action', 'receipt_print');
        uri.toString();

        if(!$('#printLinkIframe')[0]) {
          const iframe = `<iframe id="printLinkIframe" src="${uri}" name="printLinkIframe" style="display: none;"></iframe>`;
          $('body').append(iframe);

          $('#printLinkIframe').on('load', ()=> {
            el.trigger('printLinkComplete');
            frames['printLinkIframe'].focus();
            frames['printLinkIframe'].print();
          });

        } else {
          $('#printLinkIframe').attr('src', uri);
        }
      });
    }

    //SelectWoo

    $('.custom-select').each(function () {
      let theme = $(this).data('theme') || 'default';
      const id = $(this).attr('id');
      if (['your-subject', 'your-country'].includes(id)) {
        theme = 'dark';
      }

      $(this).selectWoo({
        width: '100%',
        minimumResultsForSearch: Infinity,
        theme,
      });
    });

    $('.custom-select-light').each(function () {
      let theme = $(this).data('theme') || 'light';
      const id = $(this).attr('id');
      if (['your-subject', 'your-country'].includes(id)) {
        theme = 'light';
      }

      $(this).selectWoo({
        width: '100%',
        minimumResultsForSearch: Infinity,
        theme,
      });
    });

    // Quantity Input
    $('.qty').each(function () {
      qty($(this));
    });

    //Collapsible footer menu
    new CollapseFooterMenus('max-width: 767px');


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
